import { render, staticRenderFns } from "./logout-modal.vue?vue&type=template&id=6e01c571&"
import script from "./logout-modal.vue?vue&type=script&lang=js&"
export * from "./logout-modal.vue?vue&type=script&lang=js&"
import style0 from "./logout-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports